import React from 'react';

import Slider from "react-slick";

import StorePreview, {AllStoresPreview} from 'views/designer/StorePreview';
import {Title} from 'views/AppElements';

const STORE_SLIDER_SETTINGS = {
			  autoplay: false,
			  speed: 350,
		      infinite: false,
			  
			  cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
			  className: 'storesSlider',
		      variableWidth: true,
		      dots: true,
			  slidesToShow: 4,
			  slidesToScroll: 1,
			  swipeToSlide: true,
			  swipe: true,
		      responsive: [
					      {
					      	breakpoint: 1198,
					      	settings: {
					            slidesToShow: 3,
					            slidesToScroll: 1,
					            swipeToSlide: true
					          }
					      },
					      {
					      	breakpoint: 900,
					      	settings: {
					            slidesToShow: 2,
					            slidesToScroll: 1,
					            swipeToSlide: true
					          }
					      },
					      {
					      	breakpoint: 600,
					          settings: {
					            slidesToShow: 1,
					            slidesToScroll: 1,
								swipeToSlide: true,
								arrows: true,
								dots: false
					          }
					      }
		      ]
		    };

class StoreList extends React.Component {

	componentDidUpdate() {
		//start from first slide on every update
		this.slide.slickGoTo(0);
	}

	render() {
		
		let storesDiv = null;

		if(this.props.stores) {
			storesDiv = this.props.stores.map(store => <StorePreview store={store} key={store.storeName} />);

			if(this.props.appendViewAll === true) {
				const allStorePreview = <AllStoresPreview key="allStores" />;
				storesDiv.push(allStorePreview);
			}
			
		} else {
			storesDiv = [1,2,3,4].map(i => <StorePreview store={null} key={"StoreLoader_"+i} />);
		}
			

		return <div style={{paddingBottom: '25px'}} id="storesList">
					<Title title={this.props.title} />

					<Slider {...STORE_SLIDER_SETTINGS} ref={r => this.slide=r}>
						{storesDiv}
					</Slider>
				</div>
	}
}

export default StoreList;



// WEBPACK FOOTER //
// ./src/views/designer/StoreList.js